import React from "react";
import spinner from "../assets/spinning-loading.gif";

const LoadingSpinner = () => {
  return (
    <img
      id="loading-spinner-image"
      src={spinner}
      alt="loading..."
      style={{ height: "100%", width: "100%" }}
    />
  );
};

export default LoadingSpinner;
